import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const FechaDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA' htmlFor='inputDate-fechaDocumento' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='fechaDocumento'>
          {({ field }) => <Form.InputDate {...field} id='inputDate-fechaDocumento' isInvalid={iTouched && iError} disabled={fIsSubmitting} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaDocumentoFormGroup)
